import { useSelector } from 'react-redux';
import HomeAlert from '../Components/HomeAlert';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { BsCircleFill } from 'react-icons/bs';

function HomeAlerts() {
  const homeAlerts = useSelector((state) => state.ui.homeAlerts);

  if (homeAlerts?.length <= 0) return null;

  return (
    <StyledHomeAlerts>
      <div className="AlertContainer">
        <TransitionGroup className="todo-list">
          {homeAlerts[0] && (
            <CSSTransition key={homeAlerts[0].id} timeout={500} classNames="opacity">
              <HomeAlert
                id={homeAlerts[0].id}
                variant={homeAlerts[0].variant}
                title={homeAlerts[0].title}
                message={homeAlerts[0].message}
                link={homeAlerts[0].link}
                linkMsg={homeAlerts[0].linkMsg}
              />
            </CSSTransition>
          )}
        </TransitionGroup>
      </div>
      <div className="alertCounter">
        {homeAlerts && homeAlerts?.map((alert) => <BsCircleFill key={alert.id} fontSize={10} />)}
      </div>
    </StyledHomeAlerts>
  );
}

export default HomeAlerts;

const StyledHomeAlerts = styled.div`
  display: flex;
  .AlertContainer {
    width: 96%;
  }
  .alertCounter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 4%;
    padding-bottom: 1rem;
    svg {
      margin-bottom: 0.2rem;
      color: #757575;
    }
  }
`;
